import { Box, Typography } from '@mui/material';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';

import { exportFestivalCo2Questions } from './export-festival-co2-questions/exportFestivalCo2Questions';

export function Docs() {
  return (
    <Box>
      <Typography sx={{ fontSize: '2rem', textAlign: 'center' }}>
        📄 Docs 📄
      </Typography>
      <Box sx={{ my: 2, mx: 2 }}>
        <Typography>
          Festival questions CO2 :{' '}
          <FSPrimaryButton onClick={() => exportFestivalCo2Questions()}>
            Générer fichier Excel
          </FSPrimaryButton>
        </Typography>
      </Box>
    </Box>
  );
}
